import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DonorReactionForm from './DonorReactionForm';

const DonorReactionDialog = ({ open, onClose, onSave, initialData }) => {
  const handleFormSubmit = (formData) => {
    console.log("DonorReactionDialog form submitted:", formData);
    if (onSave) onSave(formData);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Donor Reaction Worksheet
        <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <DonorReactionForm onSubmit={handleFormSubmit} initialData={initialData} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DonorReactionDialog;
